import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiMapPin, FiClock } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-secondary-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="https://app1.sharemyimage.com/2025/05/19/burbank-insurance-services-in-california-logo.png" 
                alt="Burbank Insurance Services" 
                className="h-12 w-12" 
              />
              <div>
                <h3 className="text-lg font-bold">Burbank Insurance Services</h3>
                <p className="text-sm text-secondary-300">CA License #6013543</p>
              </div>
            </div>
            <p className="text-secondary-300 mb-4">
              Protecting California families with comprehensive life insurance solutions. Licensed and trusted statewide.
            </p>
            <div className="flex items-center space-x-2 text-secondary-300">
              <SafeIcon icon={FiMapPin} className="h-4 w-4" />
              <span>Licensed in California</span>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Insurance Products</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/term-life-insurance" className="text-secondary-300 hover:text-white">
                  Term Life Insurance
                </Link>
              </li>
              <li>
                <Link to="/whole-life-insurance" className="text-secondary-300 hover:text-white">
                  Whole Life Insurance
                </Link>
              </li>
              <li>
                <Link to="/indexed-universal-life-insurance" className="text-secondary-300 hover:text-white">
                  Indexed Universal Life
                </Link>
              </li>
              <li>
                <Link to="/million-dollar-life-insurance" className="text-secondary-300 hover:text-white">
                  Million Dollar Coverage
                </Link>
              </li>
              <li>
                <Link to="/final-expense-insurance" className="text-secondary-300 hover:text-white">
                  Final Expense Insurance
                </Link>
              </li>
              <li>
                <Link to="/no-medical-exam-insurance" className="text-secondary-300 hover:text-white">
                  No Medical Exam
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Resources</h4>
            <ul className="space-y-2 text-secondary-300">
              <li>Life Insurance Calculator</li>
              <li>Coverage Guide</li>
              <li>Application Process</li>
              <li>Claims Support</li>
              <li>Policy Management</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiPhone} className="h-4 w-4 text-primary-500" />
                <a 
                  href="tel:+18184714255" 
                  className="text-secondary-300 hover:text-white"
                >
                  (818) 471-4255
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiMail} className="h-4 w-4 text-primary-500" />
                <a 
                  href="mailto:info@burbankinsuranceservices.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-secondary-300 hover:text-white"
                >
                  info@burbankinsuranceservices.com
                </a>
              </div>
              <div className="flex items-start space-x-2">
                <SafeIcon icon={FiClock} className="h-4 w-4 text-primary-500 mt-1" />
                <div className="text-secondary-300">
                  <p>Mon-Fri: 8AM-6PM PST</p>
                  <p>Sat: 9AM-3PM PST</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-800 mt-8 pt-8 text-center">
          <p className="text-secondary-400">
            © 2024 Burbank Insurance Services. All rights reserved. Licensed Insurance Agency CA #6013543
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;